//#region //* Enums
export enum AdjustmentType {
  Void = 'V',
}

export enum BenefitType {
  Holiday = 'Holiday',
}
//#endregion
